// src/pages/Waitlist.js
import React, { useState } from 'react'
import {
  Box, Typography, Container, TextField, Button
} from '@mui/material'
import { styled } from '@mui/system'
import Background from '../components/Background'
import { motion } from 'framer-motion'
import Swal from 'sweetalert2'

const MainWrapper = styled(Box)({
  position: 'relative',
  bgcolor: '#000',
  color: '#fff',
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export default function Waitlist() {
  const [email, setEmail] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async e => {
    e.preventDefault()
    setIsSubmitting(true)
    await submitEmail(email)
    setIsSubmitting(false)
  }

  const submitEmail = async (emailToSubmit) => {
    try {
      const res = await fetch(
        'https://scout-backend-ieo2.onrender.com/api/waitlist',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: emailToSubmit }),
        }
      )
      if (!res.ok) throw new Error(await res.text())
      
      Swal.fire({
        title: 'Success!',
        text: "You're on the list!",
        icon: 'success',
        confirmButtonText: 'Awesome!',
        confirmButtonColor: '#467EE5',
        background: '#1a1a1a',
        color: '#fff',
        customClass: {
          popup: 'swal-dark-theme'
        }
      })
      
      setEmail('')
    } catch {
      // Show error alert with SweetAlert2
      const result = await Swal.fire({
        title: 'Oops...',
        text: 'Submission failed. Would you like to try again?',
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: 'Try Again',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#467EE5',
        cancelButtonColor: '#666',
        background: '#1a1a1a',
        color: '#fff',
        customClass: {
          popup: 'swal-dark-theme'
        }
      })

      // If user clicks "Try Again", retry the submission
      if (result.isConfirmed) {
        await submitEmail(emailToSubmit)
      }
    }
  }

  return (
    <MainWrapper>
      <Background />
      <Container
        maxWidth="sm"
        component={motion.div}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        sx={{
          position: 'relative', zIndex: 2, textAlign: 'center',
          py: { xs: 6, md: 8 }, px: 3,
          bgcolor: 'rgba(0,0,0,0.7)', borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}
      >
        <Typography variant="h2" sx={{ fontWeight: 800, mb: 4 }}>
          Join the Waitlist
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            fullWidth label="Your Email" variant="filled" size="small"
            value={email} onChange={e => setEmail(e.target.value)}
            sx={{
              mb: 3, bgcolor: '#111', borderRadius: 1,
              '& .MuiFilledInput-root': { backgroundColor: '#111', color: '#fff' },
              '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.6)' },
            }}
          />
          <Button
            type="submit" 
            fullWidth 
            variant="contained" 
            size="large"
            disabled={isSubmitting}
            sx={{
              bgcolor: '#467EE5', 
              color: '#fff', 
              fontWeight: 700,
              textTransform: 'none', 
              borderRadius: '999px', 
              py: 1.5,
              '&:hover': { bgcolor: '#356DC7' },
              '&:disabled': { bgcolor: '#666' }
            }}
          >
            {isSubmitting ? 'Joining...' : 'Join Now'}
          </Button>
        </Box>
      </Container>
    </MainWrapper>
  )
}
